/* eslint-disable no-param-reassign */
export default {
    state: {
        mainContent: null,
    },
    getters: {
        mainContent(state) {
            return state.mainContent;
        },
    },
    mutations: {
        mainContent(state, value) {
            state.mainContent = value;
        },
    },
};
/* eslint-enable */
